export function setActivePolicyNumbers(state, payload) {
  state.activePolicyNumbers = payload;
}

export function clearActivePolicyNumbers(state) {
  state.activePolicyNumbers = undefined;
}

export function setExcessTotal(state, payload) {
  state.excessTotal = payload;
}

export function clearExcessTotal(state) {
  state.excessTotal = undefined;
}

export function setExcessRemaining(state, payload) {
  state.excessRemaining = payload;
}

export function clearExcessRemaining(state) {
  state.excessRemaining = undefined;
}

export function clearPolicyMutations(state) {
  state.activePolicyNumbers = undefined;
  state.excessTotal = undefined;
  state.excessRemaining = undefined;
}
export function addLoadingPolicy(state, payload) {
  state.loadingPolicies.push(payload);
}
export function removeLoadingPolicy(state, payload) {
  state.loadingPolicies = state.loadingPolicies.filter((policy) => policy !== payload);
}
